module.exports = __webpack_public_path__ + "img/plein.ef7aff4.svg";